<ion-content scrollY="false">
  <div class="wrapper">
      <div class="header">
          <app-title-bar
              [title]="'MY WALLET'"
              [smallFontSize]="true"
              [lineColor]="'white'"
              [gradientStartColor]="linearGradientStart"
              [gradientEndColor]="linearGradientEnd"
              [verticalGradient]="true"
              [additionalTitleStyle]="titleStyle"
          ></app-title-bar>
          <img *ngIf="(isCryptoLoggedIn$ | async) === 'evm'" class="metamask" src="assets/img/metamask.webp">
          <img *ngIf="(isCryptoLoggedIn$ | async) === 'solana'" class="phantom" src="assets/icon/phantom.png">
      </div>
      <ion-segment [value]="segment" mode="ios" class="selector" (ionChange)="segmentChanged($event)">
          <ion-segment-button value="all">
              <ion-label>ALL</ion-label>
          </ion-segment-button>
          <ion-segment-button value="favorites">
              <ion-label>FAVORITES</ion-label>
          </ion-segment-button>
      </ion-segment>
      <div class="status-block" [@inOutAnimation] *ngIf="showStatus(nftLoadingStatus$ | async)">
          <span>Loading your NFTs...</span>
      </div>
      <div class="content collections" *ngIf="segment === 'all'">
          <ng-container *ngIf="nftListInCollection$ | async as collections else noContent">
              <div class="collection" *ngFor="let collection of collections; let index = index; trackBy:trackCollection">
                  <div class="collection-header clickable" (click)="toggleSwiper(index, collection)">
                      <div class="arrow" [ngClass]="{ 'open' : swiperOpen[index] }"></div>
                      <img *ngIf="collection.imageUrl && collection.imageUrl.length > 0" class="collection-image" [src]="collection.imageUrl">
                      <span class="collection-header-title">{{collection.name}}</span>
                  </div>
                  <div class="collection-content" [ngStyle]="{'max-height': swiperOpen[index] ? '5em' : '0em'}">
                      <swiper
                          *ngIf="swiperEnabled[index]"
                          [config]="sliderOptions"
                          class="swiper"
                          (slideChange)="onSlideChange($event, collection, index)"
                          #nftSlide
                      >
                          <ng-template swiperSlide *ngFor="let nfts of collection.elements">
                              <div class="nfts">
                                  <ng-container *ngTemplateOutlet="nftImage; context:{nft: nfts[0]}"></ng-container>
                                  <ng-container *ngTemplateOutlet="nftImage; context:{nft: nfts[1]}"></ng-container>
                                  <ng-container *ngTemplateOutlet="nftImage; context:{nft: nfts[2]}"></ng-container>
                                  <ng-container *ngTemplateOutlet="nftImage; context:{nft: nfts[3]}"></ng-container>
                              </div>
                          </ng-template>
                      </swiper>
                  </div>
              </div>
          </ng-container>
      </div>
      <div class="content favorites" *ngIf="segment === 'favorites'">
          <ng-container *ngIf="favoriteNfts$ | async as favorites else noContent">
              <div class="favorite-nft" *ngFor="let favorite of favorites; trackBy: trackByUrl">
                  <ng-container *ngTemplateOutlet="nftImage; context:{nft: favorite}"></ng-container>
              </div>
          </ng-container>
      </div>
      <div class="footer">
          <span>NFT INTEGRATION<br>POWERED BY</span>
          <img>
      </div>
  </div>
</ion-content>

<ng-template let-nft="nft" #nftImage>
  <img [ngStyle]="getNftImageAsBackground(nft)" class="nfts-image clickable" (click)="select(nft,$event)" src="assets/img/blank.svg">
</ng-template>

<ng-template #loading>
  <span class="content-placeholder-text" >Loading your NFTs...</span>
</ng-template>

<ng-template #noContent>
  <span class="content-placeholder-text" >{{ segment === 'all' ? "You don't have any NFTs." : "You don't have any NFT as favorite."}}</span>
</ng-template>
